module.exports = __webpack_public_path__ + "static/img/SI.eacbd19f.png";